module.exports = __webpack_public_path__ + "img/coloured-logo.22cfe05f.svg";